import { render, staticRenderFns } from "./deptRecycleMore.vue?vue&type=template&id=4a3ca4f3&scoped=true"
import script from "./deptRecycleMore.vue?vue&type=script&lang=js"
export * from "./deptRecycleMore.vue?vue&type=script&lang=js"
import style0 from "./deptRecycleMore.vue?vue&type=style&index=0&id=4a3ca4f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ca4f3",
  null
  
)

export default component.exports